<template>
  <div no-body class="lku-arset-unearn">
    <!-- <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row> -->
    <b-row class="ml-1 mr-1">
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend
            ><label>Payment Date</label></b-input-group-prepend
          >
          <b-form-input
            v-model="tblData.tgl1"
            type="date"
            size="sm"
          ></b-form-input>
          <b-form-input
            v-model="tblData.tgl2"
            type="date"
            size="sm"
            class="ml-1"
          ></b-form-input>
        </b-input-group>
        <b-row no-gutters>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend
                ><label>Payment No.</label></b-input-group-prepend
              >
              <b-form-input
                v-model="tblData.nomor"
                placeholder="Payment Number"
                size="sm"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-form-input
                v-model="tblData.customer"
                placeholder="Customer"
                size="sm"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend
            ><label>Destination Bank</label></b-input-group-prepend
          >
          <b-form-input
            v-model="tblData.namabank"
            placeholder="Bank Name"
            size="sm"
          ></b-form-input>
          <b-form-input
            v-model="tblData.reference"
            placeholder="Reference/Cheque/giro"
            class="ml-1"
            size="sm"
          ></b-form-input>
        </b-input-group>
        <b-row no-gutters>
          <b-col lg="8">
            <b-input-group>
              <b-input-group-prepend
                ><label>Description</label></b-input-group-prepend
              >
              <b-form-input v-model="tblData.uraian" size="sm"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="4">
            <div style="text-align: right">
              <b-button variant="success" size="sm" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear</b-button
              >
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :busy="lkuLoading"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :tbody-tr-class="onRowSelected"
        @filtered="onFiltered"
        @row-clicked="selectItem"
        show-empty
      >
        <template #cell(selected)="data" >
          <template v-if="selectedrow.includes(data.item.angsurankey)">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(angsuran_ke)="data">
          <div style="width: 100%; height: 100%">
            {{ data.item.angsuran_ke }}
          </div>
        </template>
        <template v-slot:cell(tgl_jttempo)="data">{{
          data.item.tgl_jttempo | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(nilai_pokok)="data">{{
          data.item.nilai_pokok | numFormat('(0,0.00)')
        }}</template>
        <template v-slot:cell(nilai_bunga)="data">{{
          data.item.nilai_bunga | numFormat('(0,0.00)')
        }}</template>
        <template v-slot:cell(angsuran)="data">{{
          data.item.angsuran | numFormat('(0,0.00)')
        }}</template>
        <template v-slot:cell(outstand_pokok)="data">
          <span v-if="data.item.outstand_pokok > 0.009">
            {{
          data.item.outstand_pokok | numFormat('(0,0.00)')
        }}</span>
          <span v-else>0</span>
        </template>
        <template v-slot:cell(outstand_bunga)="data">
          <span v-if="data.item.outstand_bunga > 0.009">
            {{
          data.item.outstand_bunga | numFormat('(0,0.00)')
        }}</span>
          <span v-else>0</span>
          </template>
        <template v-slot:cell(outstand_denda)="data">
           <span v-if="data.item.outstand_denda > 0.009">{{
          data.item.outstand_denda | numFormat('(0,0.00)')
        }}</span>
          <span v-else>0</span></template>
        <template v-slot:cell(waktupelunasan)="data">{{
          data.item.waktupelunasan | moment("DD MMM YYYY")
        }}</template>
        <template v-slot:cell(flag)="data"></template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <b-dropdown text="Action" size="sm">
              <b-dropdown-item v-if="data.item.final == 0"
                >Revisi</b-dropdown-item
              >
              <b-dropdown-item v-if="data.item.model_pinjaman == 'PAB'"
                >Jadwal Angsuran</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item v-if="data.item.cair == 1"
                >Detail Denda/Bunga RK</b-dropdown-item
              >
              <b-dropdown-item v-if="data.item.cair == 1"
                >Collection Activity</b-dropdown-item
              >
              <b-dropdown-item v-if="data.item.cair == 1"
                >Permohonan Pelunasan</b-dropdown-item
              >
              <b-dropdown-item v-if="data.item.cair == 1"
                >History Payment & Settlement</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="3">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <b-form-select
              :options="[10, 15, 20, 25]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px !important"
            />
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style lang="scss">
.lku-arset-unearn {
  .input-group {
    padding-bottom: 2px;
    .input-group-prepend {
      label {
        padding-top: 5px;
        font-size: smaller;
        width: 90px;
      }
    }
  }
}
</style>

<script>
import installment from "../../apis/installmentkredit";
import moment from 'moment';

export default {
  data() {
    return {
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "angsuran_ke",
        sortDesc: false,
        tgl1: "",
        // moment().startOf('month').format('YYYY-MM-DD') ||this.$store.state.user.tglaktif,
        tgl2: moment().endOf('month').format('YYYY-MM-DD') || this.$store.state.user.akhirbln,
        unearned: "1",
        outstand:1,
        nasabahkey:''
      },
      lkuLoading: false,
      filter: "",
      filterOn: [],
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
            key: "selected",
            label: "Selected",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
          },
        {
          key: "angsuran_ke",
          label: "Angsuran Ke-",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur",
          thStyle: "min-width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jatuh Tempo",
          thStyle: "width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga(IDR)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran/bulan (IDR)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_denda",
          label: "Outstand Denda",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
    pagechange() {
      return this.tblData.page;
    },
    limitchange() {
      return this.tblData.limit;
    },
  },
  watch: {
    // pagechange: function (newval) {
    //   this.tblData.page = newval;
    //   this.$refs.table.refresh();
    // },
    // limitchange: function (newval) {
    //   this.$refs.table.refresh();
    // },
    // filterCustomer: function(newval) {
    //   this.refresh();
    // },
  },
  props: ["formdata", "filterdata","selectedrow","nasabahkey"],
  created: async function () {
    if (this.formdata.items) {
      for (var key in this.formdata) {
        this.tblData[key] = this.formdata[key];
      }
    } else {
      if (this.tblData.tgl1 || this.tblData.tgl2) {
        // this.refresh();
      }
    }

    if (this.filterdata) {
      for (var keydt in this.filterdata) {
        this.tblData[keydt] = this.filterdata[keydt];
      }
    }

        if(!this.selectedrow){
          this.selectedrow =[];
        }

    if(this.nasabahkey){
      this.tblData.nasabahkey = this.nasabahkey;
    }
    // this.refresh();
  },
  methods: {
    onRowSelected(item){
      if(!item) return;
      item._rowVariant = this.selectedrow.includes(item.angsurankey)?'success':''
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    selectItem(item, index) {
      // this.$emit("click", item);
      this.tblData.selected = item;
      this.$emit("click", this.tblData);
    },
    clearFilter(ctx) {
      this.tblData.reference = "";
      this.tblData.kodebank = "";
      this.tblData.namabank = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.customer = "";
      this.tblData.invoice = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nasabahkey ="";

      this.$refs.table.refresh();
    },
    data: async function (ctx) {
      console.log('this.tblData',this.tblData);
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const { list, total } = await installment.list(this.tblData);

      this.tblData.total = total;
      this.lkuLoading = false;
      return list;
      // this.$refs.tblArset.refresh();
    },
  },
};
</script>
